export const scrollToIdWithOffset = (id: string, offsetPx: number) => {
  const element = document.querySelector(id)
  if (element) {
    const bodyRect = document.body.getBoundingClientRect().top
    const elementRect = element.getBoundingClientRect().top
    const elementPosition = elementRect - bodyRect
    const offsetPosition = elementPosition - offsetPx

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
  }
}
